// extracted by css-extract-rspack-plugin
export default {"footer":"footer-FEWZaU"};